import TGlobalLoading from './global-loading.vue'
import Vue from 'vue'
import { camelcaseToHyphen } from '../../utils/assist'
TGlobalLoading.newInstance = properties => {
  const _props = properties || {}
  let props = ''
  Object.keys(_props).forEach(prop => {
    props += ' :' + camelcaseToHyphen(prop) + '=' + prop
  })
  const div = document.createElement('div')
  div.innerHTML = `<t-global-loading${props}></t-global-loading>`
  document.body.appendChild(div)
  const loaddingBar = new Vue({
    el: div,
    components: { TGlobalLoading },
    data: _props
  }).$children[0]
  return {
    update(options) {
      for (let key in options) {
        if (loaddingBar.hasOwnProperty(key)) {
          loaddingBar[key] = options[key]
        }
        if (_props.hasOwnProperty(key)) {
          _props[key] = options[key]
        }
      }
    },
    component: loaddingBar,
    destroy() {
      document.body.removeChild(div)
    }
  }
}
export default TGlobalLoading



// WEBPACK FOOTER //
// ./src/components/global-loading/global-loading.js